<div class="item" [class.last]="last" *ngIf="type == 'TOTAL'; else paymentPartial">
  <div class="info">
    <div class="quantity" [class.not-decimal]="item.qty < 10">{{ qty }}</div>
    <div class="description">
      <div class="name">{{ item.name }}</div>
      <div class="options">
        <span *ngFor="let option of item.options">{{option.qty}}x {{option.name}}</span>
      </div>
      <div class="additional-info" *ngIf="item.additionalInfo">
        Obs: {{ item.additionalInfo }}
      </div>
    </div>
  </div>
  <div class="price">{{ value | currency }}</div>
</div>

<ng-template #paymentPartial>
  <div class="item partial" [class.last]="last" (click)="toggle()">
    <div class="check" [class.checked]="(!tax && isChecked) || tax" (click)="uncheck($event)">
      <input type="checkbox" [checked]="(!tax && isChecked) || tax">
      <yoo-icon *ngIf="(!tax && isChecked) || tax" icon="check" size="small" color="#0D547F"></yoo-icon>
    </div>
    <div class="info selection">
      <div class="description">
        <div class="name" [class.tax-style]="tax">{{ item.name }}</div>
        @if(!tax){
          <div class="price" *ngIf="!item.qtySelected">{{  value | currency }}</div>
          <div class="price" *ngIf="item.qtySelected">{{ value | currency }}</div>
          <div class="options">
            <span *ngFor="let option of item.options">{{ option.qty }}x {{ option.name }}</span>
          </div>
          <div class="additional-info" *ngIf="item.additionalInfo">
            Obs: {{ item.additionalInfo }}
          </div>
        }
      </div>
    </div>
    @if(!tax){
      <div class="button" *ngIf="!isChecked">
        <mnt-button-icon
          icon="plus"
          size="medium"
          variant="emphasis"
          color="primary"
          (buttonClick)="handleSelect($event)"
        ></mnt-button-icon>
      </div>
      <div class="selector" *ngIf="isChecked" (click)="stopPropagation($event)">
        <yoo-icon icon="minus" size="small" color="#0B7CBE" *ngIf="item.qtySelected > 1" (click)="handleSub()"></yoo-icon>
        <yoo-icon icon="trash" size="small" color="#0B7CBE" *ngIf="item.qtySelected == 1" (click)="handleSub()"></yoo-icon>
        <span>{{ item.qtySelected }}</span>
        <yoo-icon icon="plus" size="small" [color]="canIncrease ? '#0B7CBE' : '#4B5053'" (click)="handlePlus()"></yoo-icon>
      </div>
    }@else {
      <div class="price align-right" *ngIf="!item.qtySelected">{{ item.value | currency }}</div>
    }
  </div>
</ng-template>
